import { Model, hasMany } from 'miragejs';

export default Model.extend({
  companyRoles: hasMany(),
  zoneRoles: hasMany(),
  emails: hasMany(),
  employees: hasMany(),
  locationRoles: hasMany(),
  phoneNumbers: hasMany(),
  notificationPreferences: hasMany(),
  userDocuments: hasMany(),
});
